import { z } from "zod";
import { adminOperatorIdSchema, adminUlidSchema } from "./admin-operations-core.js";
import { adminGoodwillReasonSchema } from "./admin-operations-investigations.js";
import { adminSupportWorkspaceSchemaVersionSchema } from "./admin-operations-support-workspace.js";
import { customerOperationsOpaqueIdSchema } from "./customer-operations-core.js";
import { supportTicketIdempotencyKeySchema } from "./customer-operations-support.js";
const base = {
    schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
    commandId: supportTicketIdempotencyKeySchema,
};
export const adminSupportRemedyCommandSchema = z.discriminatedUnion("action", [
    z
        .object({
        ...base,
        action: z.literal("ISSUE_COURTESY"),
        expectedVersion: z.number().int().positive(),
        reason: adminGoodwillReasonSchema,
    })
        .strict(),
    z
        .object({
        ...base,
        action: z.literal("RETRY_COURTESY_EMAIL"),
        expectedEmailVersion: z.number().int().positive(),
    })
        .strict(),
]);
export const adminSupportRemedyStatusCommandSchema = z
    .object({
    schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
    view: z.literal("COURTESY"),
})
    .strict();
export const adminSupportCourtesyReceiptSchema = z
    .object({
    schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
    commandId: supportTicketIdempotencyKeySchema,
    action: z.literal("ISSUE_COURTESY"),
    voucherId: adminUlidSchema,
    entitlementId: adminUlidSchema,
    caseId: adminUlidSchema,
    reason: adminGoodwillReasonSchema,
    performedBy: adminOperatorIdSchema,
    issuedAt: z.string().datetime(),
    previousVersion: z.number().int().positive(),
    version: z.number().int().positive(),
})
    .strict()
    .refine((row) => row.version === row.previousVersion + 1);
export const adminSupportCourtesyEmailSchema = z
    .object({
    state: z.enum([
        "PENDING",
        "SENDING",
        "ACCEPTED",
        "NEEDS_ATTENTION",
        "UNKNOWN",
        "UNRECOVERABLE_LEGACY",
    ]),
    version: z.number().int().nonnegative(),
    attempts: z.number().int().nonnegative(),
    canRetry: z.boolean(),
    reasonCode: z
        .enum([
        "NOT_ACCEPTED",
        "PROFILE_CHANGED",
        "VOUCHER_UNAVAILABLE",
        "RECOVERY_MATERIAL_UNAVAILABLE",
        "SEND_UNCONFIRMED",
        "LEGACY_HASH_ONLY",
    ])
        .optional(),
})
    .strict();
export const adminSupportRemedyStatusResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
        ticketId: customerOperationsOpaqueIdSchema,
        remedy: z.discriminatedUnion("state", [
            z.object({ state: z.literal("NOT_ISSUED") }).strict(),
            /**
             * No courtesy cutover date is set for this deployment, so none can be offered yet; this
             * is not a request that needs its history reviewed (stage 2, B2).
             */
            z.object({ state: z.literal("NOT_SWITCHED_ON") }).strict(),
            z.object({ state: z.literal("LEGACY_REVIEW_REQUIRED") }).strict(),
            z
                .object({
                state: z.literal("LEGACY_ISSUED"),
                voucherId: adminUlidSchema,
                email: adminSupportCourtesyEmailSchema,
            })
                .strict(),
            z
                .object({
                state: z.literal("ISSUED"),
                receipt: adminSupportCourtesyReceiptSchema,
                email: adminSupportCourtesyEmailSchema,
            })
                .strict(),
        ]),
    })
        .strict(),
})
    .strict();
export const adminSupportRemedyResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
        ticketId: customerOperationsOpaqueIdSchema,
        commandId: supportTicketIdempotencyKeySchema,
        action: z.enum(["ISSUE_COURTESY", "RETRY_COURTESY_EMAIL"]),
        performedBy: adminOperatorIdSchema,
        recordedAt: z.string().datetime(),
        receipt: adminSupportCourtesyReceiptSchema,
    })
        .strict(),
    email: adminSupportCourtesyEmailSchema,
})
    .strict();
//# sourceMappingURL=admin-operations-support-remedy.js.map